// @ts-nocheck
/* eslint-disable */
import MyMapsPopup from "~/es6/mymaps.popup";
import { _ } from "~/i18n";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { node } from "~/util/dom";

/**
 * Signaly:
 * rename { name: new value }
 * delete {}
 */
window.Popup = class {
	constructor(opts) {
		this._opts = Object.assign({
			items: null, // objekt|pole ojektu
			delete: false, // smazat?
			remove: false, // odebrat
			rename: false, // prejmenovat
			duplicate: false, // duplikace slozky
			actualFolderId: null, //aktuální složka pro vynucený refresh
			cb: null, // callback
			reverseMode: false, // items jsou ty, ktere zustanou ve slozce zachovany
			itemsCount: 0, // pokud se jedna o reverse mode, ukazuje se jen pocet polozek, pac ostatni nazvy nemusime znat
		}, opts);
		this._popup = new MyMapsPopup({
			name: "places-popup"
		});
		this._dom = {
			container: this._popup.getContainer()
		};

		let parsedData = this._parse();

		this._ids = parsedData.ids;
		this._title = parsedData.title;
		this._isFolder = parsedData.isFolder;
		this._types = parsedData.types;

		this._create();
		this._pre();
		this._popup.open();
		this._post();
	}

	/**
	 * Zavreni popupu.
	 */
	close() {
		this._popup.close();
	}

	handleEvent(e) {
		switch (e.type) {
			case "click":
				if (e.target == this._dom.saveBtn) {
					e.stopPropagation();

					this._save();
				} else if (e.target == this._dom.cancelBtn) {
					e.stopPropagation();
					this.close();
				}
				break;

			case "keydown":
				let keyCode = e.which || e.keyCode;

				if (keyCode == 13) {
					if (e.target == this._dom.renameInput || e.target == this._dom.folderNameInput) {
						this._save();
					}
				}
				break;
		}
	}

	/**
	 * Parsovani vstupnich dat.
	 *
	 * @return {Object}
	 */
	_parse() {
		let ids = [];
		let title = [];
		let types = [];
		let items = this._opts.items ? (Array.isArray(this._opts.items) ? this._opts.items : [this._opts.items]) : [];
		let single = items.length == 1 && !this._opts.reverseMode;

		items.forEach(i => {
			title.push(i.title);
			ids.push(i.id);
			types.push(i.type == "link" ? i.linktype : i.type);
		});

		if (this._opts.reverseMode) {
			title = [_("mymap.places.remove.items.popup", { count: this._opts.itemsCount - items.length })];
		}

		return {
			ids: single ? ids[0] : ids,
			title: title.join(", ") || "",
			isFolder: single ? items[0].type == "folder" : false,
			types
		};
	}

	/**
	 * Vytvoreni popupu pro pridani.
	 */
	_create() {
		let header = node("h2", {className: "header"});
		let content = node("div", {className: "content"});
		let buttons = node("div", {className: "buttons"});
		let saveBtn = node("button", {className: "save"});
		saveBtn.setAttribute("type", "button");
		let cancelBtn = node("button", {className: "cancel", textContent: _("cancel")});
		cancelBtn.setAttribute("type", "button");
		let error = node("p", {className: "error"});

		buttons.appendChild(saveBtn);
		buttons.appendChild(cancelBtn);

		this._dom.container.appendChild(header);
		this._dom.container.appendChild(content);
		this._dom.container.appendChild(buttons);
		this._dom.container.appendChild(error);

		this._dom.error = error;
		this._dom.saveBtn = saveBtn;
		this._dom.cancelBtn = cancelBtn;
		this._dom.content = content;
		this._dom.header = header;
		this._dom.buttons = buttons;

		// eventy
		this._dom.saveBtn.addEventListener("click", this);
		this._dom.cancelBtn.addEventListener("click", this);
	}

	/**
	 * Operace pred vytvoreni a zobrazenim popupu.
	 */
	_pre() {
		if (this._opts.rename) {
			// vytvorime prejmenovavaci formular
			this._dom.content.classList.add("rename");
			this._dom.header.textContent = _("rename");
			this._dom.saveBtn.textContent = _("rename");

			this._dom.renameInput = node("input", {className: "value", type: "text", value: this._title.slice(0, 200), maxLength: 200 });
			this._dom.renameInput.addEventListener("keydown", this);
			this._dom.content.appendChild(this._dom.renameInput);
		} else if (this._opts.delete) {
			this._dom.content.classList.add("delete");
			this._dom.header.textContent = _("delete");
			this._dom.saveBtn.textContent = _("delete");
			this._dom.content.appendChild(node("h3", {className: "title", textContent: this._title}));
		} else if (this._opts.remove) {
			this._dom.content.classList.add("delete");
			this._dom.header.textContent = _("mymap.places.removeActivity.title");
			this._dom.saveBtn.textContent = _("mymap.places.removeActivity.remove");
			this._dom.content.appendChild(node("p", {className: "description", textContent: _("mymap.places.removeActivity.desc")}));
			this._dom.content.appendChild(node("h3", {className: "title", textContent: this._title}));
		} else if (this._opts.duplicate) {
			this._dom.content.classList.add("duplicate");
			this._dom.header.textContent = _("mymap.places.copyFolder");
			this._dom.saveBtn.textContent = _("save");

			this._dom.folderNameInput = node("input", {className: "value", type: "text", value: this._title});
			this._dom.folderNameInput.addEventListener("keydown", this);
			this._dom.content.appendChild(this._dom.folderNameInput);
		}
	}

	/**
	 * Operace po vytvoreni a zobrazeni popupu.
	 */
	_post() {
		if (this._opts.rename) {
			this._dom.renameInput.focus();
		} else if (this._opts.duplicate) {
			this._dom.folderNameInput.focus();
		}
	}

	/**
	 * Zobrazeni chybove hlasky.
	 *
	 * @param  {String} [msg] Hlaska
	 */
	_error(msg) {
		this._dom.error.textContent = msg || "";
		this._dom.error.classList[msg ? "remove" : "add"]("hide");
	}

	/**
	 * Poslani signalu - otevreni, zavreni editace, nastaveni slozky.
	 *
	 * @param  {String} name Nazev signalu
	 * @param  {Object} data Vlastni data
	 */
	_sendSignal(name, data) {
		if (typeof this._opts.cb === "function") {
			this._opts.cb(Object.assign({
				name
			}, data));
		}
	}

	/**
	 * Ulozeni - zmacknuti zeleneho tlacitka se pak ridi podle typu popupu.
	 */
	_save() {
		this._error("");

		if (this._opts.rename) {
			let renameValue = this._dom.renameInput.value.trim();

			if (!renameValue) {
				this._error(_("mymap.places.errorEmptyRename"));
			} else if (this._title != renameValue) {
				let updateProm = null;

				if (this._isFolder) {
					updateProm = Mapy.ProviderMapyBox.folderUpdate(this._ids, {
						title: renameValue
					});
				} else {
					updateProm = Mapy.ProviderMapyBox.likeUpdate(this._ids, {
						usertitle: renameValue
					});
				}

				this.close();

				updateProm.then(ok => {
					this._sendSignal("rename", {name: renameValue});
					this._notification(_("mymap.places.renameOk"));
				}, e => {
					this._notification(_("mymap.places.errorRename"), true);
					// eslint-disable-next-line no-console
					console.error(e);
				});
			} else if (this._title == renameValue) {
				this.close();
			}
		} else if (this._opts.delete || this._opts.remove) {
			let updateProm = this._isFolder ? Mapy.ProviderMapyBox.folderDelete(this._ids) : Mapy.ProviderMapyBox.likeDelete(this._ids, {
				folderId: this._opts.reverseMode ? this._opts.actualFolderId : "",
			});

			this.close();

			updateProm.then(ok => {
				if (!this._isFolder && this._types.includes("route") && this._opts.actualFolderId) {
					Mapy.ProviderMapyBox.removeFolderFromCache(this._opts.actualFolderId);
					Mapy.ProviderMapyBox.folderList(this._opts.actualFolderId).then(() => {
						this._notifyAfterDelete();
					}, e => {});
				} else {
					this._notifyAfterDelete();
				}
			}, e => {
				this._notification(_("mymap.places.errorRemove"), true);
				// eslint-disable-next-line no-console
				console.error(e);
			});
		} else if (this._opts.duplicate) {
			let renameValue = this._dom.folderNameInput.value.trim();

			if (!renameValue) {
				this._error(_("mymap.places.errorEmptyRename"));
			} else {
				this.close();
				this._sendSignal("rename", {name: renameValue});
			}
		}
	}

	_notifyAfterDelete() {
		this._sendSignal("remove");

		let notMsg = "";

		if (this._isFolder) {
			notMsg = _("mymap.places.remove.folder");
		} else if (Array.isArray(this._ids)) {
			notMsg = _("mymap.places.remove.items");
		} else if (this._opts.remove) {
			notMsg = _("mymap.places.removeActivity.removeConfirm");
		} else {
			let type = this._types[0];

			switch (type) {
				case "entity":
				case "point":
					notMsg = _("mymap.places.remove.place");
					break;

				case "track":
				case "photo":
				case "measure":
				case "set":
				case "route":
					notMsg = _("mymap.places.remove." + type);
					break;
			}
		}

		this._notification(notMsg);
		Mapy.getComponent("places").updateLikeList();
	}

	/**
	 * Notifikace.
	 *
	 * @param  {String|Element} content Obsah zpravy
	 * @param  {Boolean} [isError] Jedna se o chybu?
	 */
	_notification(content, isError) {
		Notifications.notify({
			content,
			type: isError ? NOTIFICATIONS_TYPE.ERROR : NOTIFICATIONS_TYPE.SUCCESS
		});
	}
}
